import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=2d1d1a15&scoped=true&"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGeneral.vue?vue&type=style&index=0&id=2d1d1a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d1a15",
  null
  
)

export default component.exports